module.exports = __webpack_public_path__ + "img/paylogo.970968f4.png";